import React, {Component} from 'react'
import ReactTooltip from 'react-tooltip'
import EdgebetRow from './EdgebetRow'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

let headerToolTips = {
  match: 'This is the participants who plays. We always display the home team first - so if your bookmaker is showing it in a different order - you need to take an extra look. Home to win means that the team displayed first here at edgebet should win.',
  startTime: 'Time until kick off. We at edgebet recommend you place bets no more than 12 hours before the game. The closer to kick off, the better!',
  bookmaker: 'This is where you should place your bet.',
  oddsType: 'This is the odds type you should bet on. You can read more information about all the odds types in our forum!',
  odds: 'Make sure the odds on the bookmaker is the same as we display here. If not, don\'t place the bet!',
  kelly: 'This is our recommended bet size! Derived from the Kelly Criterion, this optimizes your winnings while decreasing variance.',
  edge: 'This is the expected value of the bet. You can expect to make this percentage of your wager on average on this bet.'
}

export default class EdgebetTable extends Component {

  constructor(props) {
    super(props)
    this.columns = [
      {text: 'Match', key: 'match', className:'col-xs-5 col-lg-4'},
      {text: 'Start', key: 'startTime', className: 'md-up-only', sortable:true},
      {text: 'Bookmaker', key:'bookmaker', className:'col-xs-2 col-sm-2 col-md-1'},
      {text: 'Odds type', key:'oddsType', className:'lg-up-only', sortable:false},
      {text: 'Odds', key: 'odds', className:'lg-up-only', sortable:true},
      {text: 'Betsize', key:'kelly', sortable:true},
      {text: 'Edge', key:'edge', className:'', sortable:true},
    ]
    this.state = {
      sortedColumn: 'kelly',
      sortedDescending: true,
    }
    this.sortEdges = this.sortEdges.bind(this)
    this.handleClickHeader = this.handleClickHeader.bind(this)
  }

  sortEdges(edges) {
    let multiplier = this.state.sortedDescending ? 1 : -1
    return edges.sort((a, b) => {
      let sorted = (b[this.state.sortedColumn] - a[this.state.sortedColumn]) * multiplier
      if (sorted === 0)
        return a.offer - b.offer
      return sorted
    })
  }

  handleClickHeader(column) {
    let changes = {}
    if (this.state.sortedColumn === column) {
      changes.sortedDescending = !this.state.sortedDescending
    } else {
      changes.sortedColumn = column
      changes.sortedDescending = true
    }
    if (Object.keys(changes).length > 0)
      this.setState(changes)
  }

  render() {
    let edgebets = this.sortEdges(this.props.edgebets)
    let edgebetNodes = edgebets.map(edgebet => {
      let userbet = this.props.userbets.filter(bet => bet.match._id === edgebet.matchId)[0]
      return (
          <EdgebetRow
            key={edgebet.key}
            onClick={this.props.onEdgeSelected}
            selected={edgebet.key === this.props.selected}
            user={ this.props.user }
            userbet={ userbet }
            totalBankroll={this.props.totalBankroll}
            kellyFrac={this.props.user.kellyFrac}
            {... edgebet }
            edgeKey={edgebet.key} />
        )
    })

    if(edgebetNodes.length === 0) {
      edgebetNodes = <tr><td colSpan='5'>There are no edgebets matching this filter</td></tr>
    }

    return (
      <div className='col-md-12 edgebet-table-container'>
        <table className='table table-responsive edgebet-table'>
          <thead>
            <tr>
              { this.columns.map(col => {
                let className
                let handleClick = null
                if (col.sortable) {
                  handleClick = this.handleClickHeader.bind(this, col.key)
                  if (col.key === this.state.sortedColumn) {
                    if (this.state.sortedDescending)
                      className = 'text-success text-bold'
                    else className = 'text-danger text-bold'
                  }
                }
                return (
                  <th
                    className={col.className + (!!className ? ' ' + className : '' )}
                    key={col.key}
                    onClick={handleClick}
                    data-tip={headerToolTips[col.key]}
                    data-for='edgebet-table-header'>
                    { col.text }
                  </th>
                )
              })}
            </tr>
          </thead>
          <ReactCSSTransitionGroup transitionName='edgebet-animation' transitionEnter={this.props.shouldAnimate} transitionLeave={this.props.shouldAnimate} transitionLeaveTimeout={1500} transitionEnterTimeout={2500} component='tbody'>
            {edgebetNodes}
          </ReactCSSTransitionGroup>
        </table>
        <ReactTooltip id='edgebets' place='top' effect='solid'/>
        <ReactTooltip id='edgebet-table-header' place='bottom' />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/edgebets/EdgebetTable.js
 **/